import { render, staticRenderFns } from "./BsModal.vue?vue&type=template&id=8cbe559a"
import script from "./BsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BsModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports